<div class="dropdown group_input">
  <a [ngClass]="{'short-text': shortText}" [ngClass]="{'dropdown-toggle': canSelect}" class="selected-name" id="navbarDropdown" role="button"
    aria-haspopup="true" data-toggle="dropdown" aria-expanded="false" (click)="onClickMenu()">
    {{ selectedDropDownName | translate }}
  </a>
  <ul *ngIf="canSelect" [ngClass]="{'show': showDropDownMenu, 'short-text': shortText}" class="dropdown-menu m-0"
    aria-labelledby="navbarDropdown">
    <li *ngFor="let item of items">
      <a class="dropdown-item" [ngClass]="{'selected': value && value == item.value}"
        (click)="onSelectValue(item.value)">
        {{ item.name | translate }}
      </a>
    </li>
  </ul>
</div>
